import { name as root } from '../actionTypes';

export const name = `${root}/profile`

export const FETCH_PROFILE_REQUEST = `${name}/fetch/request`
export const FETCH_PROFILE_SUCCESS = `${name}/fetch/success`
export const FETCH_PROFILE_FAILURE = `${name}/fetch/failure`

export const FETCH_OTTSTATUS_REQUEST = `${name}/ott/fetch/request`
export const FETCH_OTTSTATUS_SUCCESS = `${name}/ott/fetch/success`
export const FETCH_OTTSTATUS_FAILURE = `${name}/ott/fetch/failure`

export const SEND_SMS_REQUEST = `${name}/sms/send/request`;
export const SEND_SMS_SUCCESS = `${name}/sms/send/success`;
export const SEND_SMS_FAILURE = `${name}/sms/send/failure`;
export const TOGGLE_SMS_BUTTON = `${name}/sms/toggleButton`;
export const SET_SMS_PHONENUMBER = `${name}/sms/setPhoneNumber`;

export const UPDATE_CUSTOMER_REQUEST = `${name}/update/request`;
export const UPDATE_CUSTOMER_SUCCESS = `${name}/update/success`;
export const UPDATE_CUSTOMER_FAILURE = `${name}/update/failure`;

export const UPDATE_FORM_SET_PROPERTY = `${name}/updateForm/setProperty`;
export const UPDATE_FORM_CLEAR = `${name}/updateForm/clear`;

export const SAVE_START = `${name}/updateForm/savestart`;
export const SAVE_STOP = `${name}/updateForm/savestop`;